const RUNES = Array.from({ length: 12 }, (_, index) => index);

export function DivineHalo({ idPrefix }: { idPrefix: string }) {
  const grad = `${idPrefix}-halo`;
  return (
    <span className="fx__halo-slot">
      <svg className="fx__halo" viewBox="0 0 100 100" aria-hidden="true">
        <defs>
          <linearGradient id={grad} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="55%" stopColor="#f5e6c8" />
            <stop offset="100%" stopColor="#e8c97a" />
          </linearGradient>
        </defs>
        <circle cx="50" cy="50" r="36" fill="none" stroke={`url(#${grad})`} strokeWidth="3.4" />
        <circle cx="50" cy="50" r="30" fill="none" stroke="#fffef8" strokeWidth="0.6" opacity="0.85" />
        <circle
          cx="50"
          cy="50"
          r="42"
          fill="none"
          stroke="#f5e6c8"
          strokeWidth="0.7"
          strokeDasharray="1.2 3.2"
          opacity="0.8"
        />
        <g className="fx__halo-runes">
          {RUNES.map((index) => {
            const angle = (index / RUNES.length) * Math.PI * 2 - Math.PI / 2;
            const x = 50 + Math.cos(angle) * 36;
            const y = 50 + Math.sin(angle) * 36;
            return <rect key={index} x={x - 1.3} y={y - 1.3} width="2.6" height="2.6" fill="#fffef8" transform={`rotate(45 ${x} ${y})`} />;
          })}
        </g>
      </svg>
    </span>
  );
}
